import _ from "lodash";
import axios from "axios";
import getApi from "./index";

export async function list(filters = {}) {
  const promise = await new Promise(async (resolve, reject) => {
    try {
      const api = await getApi();

      const response = await api.get("/document/", {
        params: {
          has_pagination: true,
          ...filters,
        },
      });

      const { data } = response;

      resolve(data.results);

      // if (status >= 200 && status <= 300) {
      //
      //   const results = data.map((result)=> {
      //     return {
      //       ...result,
      //       orders: result.orders.map((order)=> {
      //         const page = _.get(order, 'original_content.pagina_inicial', 0) + 1;
      //         const pdf_id = _.get(order, 'original_content.pdf_id');
      //         return {
      //           ...order.parsed_content,
      //           id: order.id,
      //           status: order.status,
      //           created_at: order.created_at,
      //           order_number: order.order_number,
      //           temp_order_number: order.temp_order_number,
      //           pdf_id: pdf_id,
      //           initial_page: page,
      //           attempt_quantity_export: (order.attempt_revised_content || []).length
      //         }
      //       })
      //     }
      //   });
      //
      // 	resolve(results);
      // } else {
      // 	reject(new Error('Não foi possível listar os documentos!'));
      // }
    } catch (e) {
      reject(new Error(e));
    }
  });

  return promise;
}

export async function getDocument(id) {
  const promise = new Promise(async (resolve, reject) => {
    try {
      const api = await getApi();
      const response = await api.get(`/document/${id}/orders/`);
      const { data } = response;

      resolve({
        ...data,
        orders: data.orders.map((order) => {
          const page = _.get(order, "original_content.pagina_inicial", 0) + 1;
          const pdf_id = _.get(order, "original_content.pdf_id");
          const customer_info = _.get(
            order,
            "original_content.informacao_cliente",
          );

          return {
            ...order.parsed_content,
            reference: order.reference,
            id: order.id,
            invalid_reason: order.invalid_reason,
            customer_info: customer_info,
            status: order.status,
            created_at: order.created_at,
            order_number: order.order_number,
            temp_order_number: order.temp_order_number,
            pdf_id: pdf_id,
            initial_page: page,
            attempt_quantity_export: (order.attempt_revised_content || [])
              .length,
            exists_in_other_order: order.exists_in_other_order,
            duplicate_reference: order.duplicate_reference,
          };
        }),
      });
    } catch (e) {
      reject(new Error("Não foi possível obter os detalhes do documento!"));
    }
  });

  return await promise;
}

export async function upload(
  file,
  onCallbackProgress,
  ignoreWarning = false,
  password = null,
) {
  return await new Promise(async (resolve, reject) => {
    let uploadKey;

    try {
      const jsonApi = await getApi();
      const ticketResponse = await jsonApi.post("/document/upload-ticket/", {
        filename: file.name,
        size: file.size,
      });

      const { upload: uploadTicket, upload_key } = ticketResponse.data;
      uploadKey = upload_key;

      const s3Form = new FormData();
      Object.entries(uploadTicket.fields).forEach(([key, value]) => {
        s3Form.append(key, value);
      });

      s3Form.append("file", file, file.name);

      await axios.post(uploadTicket.url, s3Form, {
        timeout: 60000 * 5,
        onUploadProgress: (data) => {
          onCallbackProgress(Math.round((100 * data.loaded) / data.total));
        },
      });
    } catch (e) {
      const backendMessage =
        e.response &&
        e.response.data &&
        typeof e.response.data.message === "string"
          ? e.response.data.message
          : null;
      reject(
        new Error(
          backendMessage ||
            "Não foi possível enviar o arquivo. Tente novamente.",
        ),
      );
      return;
    }

    try {
      const headers = {
        "Content-Type": "multipart/form-data",
      };

      const confirmForm = new FormData();
      confirmForm.append("upload_key", uploadKey);

      if (ignoreWarning) {
        confirmForm.append("ignore_warning", "true");
      }

      if (password) {
        confirmForm.append("password", password);
      }

      const confirmApi = await getApi(headers);
      const response = await confirmApi.post(`/document/`, confirmForm);
      const { status, data } = response;

      if (status >= 200 && status <= 300) {
        resolve({
          ...data.document,
          orders: [],
        });
      } else {
        reject(new Error("Não foi possível enviar a arquivo!"));
      }
    } catch (e) {
      if (e.response && e.response.status === 409) {
        const errorData = e.response.data;
        const duplicateError = new Error(
          errorData.message || "Arquivo duplicado detectado",
        );
        duplicateError.isDuplicate = true;
        duplicateError.status = errorData.status;
        duplicateError.response = e.response;
        reject(duplicateError);
      } else if (e.response && e.response.status === 403) {
        const errorData = e.response.data;
        const duplicateError = new Error(
          errorData.message || "Sem permissões para enviar o arquivo",
        );
        duplicateError.isDuplicate = true;
        duplicateError.status = errorData.status;
        duplicateError.response = e.response;
        reject(duplicateError);
      } else if (e.response && e.response.status === 400) {
        const errorData = e.response.data;
        let errorInfo = errorData.message || "Erro ao enviar o arquivo";

        if (!_.isEmpty(errorData.info)) {
          try {
            const parsedInfo = JSON.parse(errorData.info);
            errorInfo = parsedInfo.error || errorData.message;
          } catch (parseError) {
            // Manter a mensagem original se a análise falhar
          }
        }

        const duplicateError = new Error(errorInfo);
        duplicateError.isDuplicate = true;
        duplicateError.status = errorData.status;
        duplicateError.response = e.response;

        reject(duplicateError);
      } else {
        reject(new Error(e.message || e));
      }
    }
  });
}

export async function getPDFData({ item, calculationDecimalPlaces }) {
  return await new Promise(async (resolve, reject) => {
    try {
      if (!item.identifier) {
        reject(new Error("Identificador do documento não fornecido!"));
        return;
      }

      if (!calculationDecimalPlaces) {
        reject(new Error("Cálculo de casas decimais não fornecidos!"));
        return;
      }

      const api = await getApi(undefined, { responseType: "blob" });

      const params = {
        calculation_decimal_places: calculationDecimalPlaces,
      };
      const response = await api.get(`/document/${item.identifier}/data/`, {
        params,
      });
      const blob = response.data;
      const headers = response.headers || {};
      const contentType = (
        headers["content-type"] ||
        headers["Content-Type"] ||
        ""
      ).toLowerCase();

      if (contentType.includes("application/json")) {
        const text = await blob.text();
        const parsed = JSON.parse(text);
        resolve(parsed);
        return;
      }

      if (
        !contentType.includes(
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        ) &&
        !contentType.includes("application/vnd.ms-excel")
      ) {
        reject(
          new Error("Formato de arquivo inválido. Esperado arquivo Excel."),
        );
        return;
      }

      let filename = item.identifier;
      const disposition =
        headers["content-disposition"] || headers["Content-Disposition"] || "";
      const fileNameMatch = disposition.match(
        /filename\*=UTF-8''([^;\n\r]+)|filename="?([^";\n\r]+)"?/,
      );
      if (fileNameMatch) {
        filename = decodeURIComponent(fileNameMatch[1] || fileNameMatch[2]);
      }

      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);

      resolve({ downloaded: true, fileName: filename });
    } catch (error) {
      if (error.response && error.response.data instanceof Blob) {
        try {
          const errorText = await error.response.data.text();
          const errorData = JSON.parse(errorText);
          const apiErrorMessage =
            errorData.message ||
            "Não foi possível baixar o relatório. CÓD: 001";
          reject(new Error(apiErrorMessage));
          return;
        } catch (parseError) {
          reject(new Error("Não foi possível baixar o relatório. CÓD: 002"));
          return;
        }
      }
      reject(new Error("Não foi possível baixar o relatório. CÓD: 003"));
    }
  });
}
